const nativeUserTabMapping = {
    profile: 0,
    security: 1,
    account: 2,
    billing: 3,
};

const federatedUserTabMapping = {
    profile: 0,
    account: 1,
    billing: 2,
};

function getTabMapping (isFederated) {
    return isFederated ? federatedUserTabMapping : nativeUserTabMapping;
}

export function getVisibleTabsConfig (isFederated) {
    return [
        { id: 'profile', label: 'User', visible: true },
        { id: 'security', label: 'Security', visible: !isFederated },
        { id: 'org', label: 'Account', visible: true },
        { id: 'billing', label: 'Billing', visible: true },
    ].filter(tab => tab.visible);
}

export function getTabByPath ({path, isFederated}) {
    const tabMapping = getTabMapping(isFederated);
    if (!path) {
        return 0;
    }
    let tabIndex = 0;
    Object.keys(tabMapping).forEach((key) => {
        if (path.indexOf(key) !== -1) {
            tabIndex = tabMapping[key];
        }
    });
    return tabIndex;
}

export function getPathByTab ({tabIndex, isFederated}) {
    const tabMapping = getTabMapping(isFederated);
    let path = 'profile';
    Object.keys(tabMapping).forEach((key) => {
        if (tabMapping[key] === tabIndex) {
            path = key;
        }
    });
    return `/admin/settings/${path}`;
}
